<template>
    <el-dialog :visible.sync="dealdialogVisible" :before-close="cancelForm" width="40%" center :append-to-body="appendToBody">
        <template slot="title">
            <div class="add_title">
                {{ title }}
            </div>
        </template>
        <div class="authority">
            <!-- <div class="title">新增规则</div> -->
            <div class="info">
                <div class="user">
                    <div class="basic_box">
                        <div class="basic_title">
                            <div>系统告警</div>
                            <img src="../../../assets/文本.png" alt="">
                        </div>
                        <div class="basic_text">
                            {{ form.noti_detail }}
                        </div>
                        <div class="basic_title">
                            <div>原因说明</div>
                            <img src="../../../assets/文本.png" alt="">
                        </div>
                        <div class="reason_box">
                            <!-- <div class="hardware_reason">
                                <div class="reason_name">
                                    硬件原因
                                </div>
                                <el-checkbox-group v-model="hardwareradio">
                                    <el-checkbox :label="item.name" v-for="item in hardwarerlist">{{ item.name
                                        }}</el-checkbox>
                                </el-checkbox-group>
                            </div> -->
                            <div class="hardware_reason">
                                <el-radio-group v-model="radio" @input="onCauseChange">
                                    <template v-for="item in reasonlist">
                                        <el-popover
                                            v-if="item.name === '数据值不可信'"
                                            placement="bottom"
                                            :width="120"
                                            trigger="click"
                                            :key="item.id"
                                        >
                                            <button class="wrap-btn" @click.prevent="onCauseChange('数据值不可信')" slot="reference">
                                                <el-radio :label="item.name">{{ item.name }}</el-radio>
                                            </button>
                                            <el-checkbox-group v-model="causeList">
                                                <el-checkbox label="传感器故障"></el-checkbox>
                                                <el-checkbox label="执行机构故障"></el-checkbox>
                                                <el-checkbox label="设备掉线"></el-checkbox>
                                                <el-checkbox label="现场断电"></el-checkbox>
                                                <el-checkbox label="网络失联"></el-checkbox>
                                            </el-checkbox-group>
                                        </el-popover>
                                        <el-radio v-else :label="item.name"  :key="item.id">{{ item.name }}</el-radio>
                                    </template>
                                    
                                </el-radio-group>
                            </div>
                            <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="resontextarea" v-if="radio === '其他原因'">
                            </el-input>
                            <!-- <div class="another_reason">
                                <div class="reason_name">
                                    其他原因
                                </div>
                                <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="resontextarea">
                                </el-input>
                            </div> -->
                        </div>
                        <div class="basic_title">
                            <div>操作说明</div>
                            <img src="../../../assets/文本.png" alt="">
                        </div>
                        <div class="action_box">
                            <el-input type="textarea" :rows="8" placeholder="请输入内容" v-model="actiontextarea">
                            </el-input>
                        </div>
                    </div>

                    <div class="demo-drawer__footer">
                        <el-button type="primary" @click="commitForm">确认提交</el-button>
                        <el-button class="cancelbutton" @click="cancelForm">取 消</el-button>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import config from '@/utils/config';
export default {
    props: {
        dealdialogVisible: Boolean,
        title: String,
        infoid: Number,
        appendToBody: {
            type: Boolean,
            default: false,
        }
    },
    components: {},
    data() {
        return {
            form: {

            },
            hardwarerlist: [
                {
                    name: '现场断电',
                    id: 0,
                }, {
                    name: '网络失联',
                    id: 1,
                }, {
                    name: '服务器宕机',
                    id: 2,
                }
            ],
            reasonlist: [
                {
                    name: '数据值可信',
                    id: 0,
                }, {
                    name: '数据值不可信',
                    id: 1,
                }, {
                    name: '其他原因',
                    id: 2,
                },
            ],
            gradelist: [],
            moduleslist: [],
            operatelist: [],
            tagslist: [],
            module_info: null,
            level_info: null,
            type_info: null,
            resontextarea: null,
            actiontextarea: null,
            hardwareradio: [],
            radio: null,
            status: null,
            causeList: [],
        };
    },
    mounted() { },
    created() {
        // if (this.title == '编辑告警定义') {
        // }
        if (this.title == '处理原因说明') {
            this.status = 2
        } else {
            this.status = 3
        }
        this.getlist()
        // this.getdependlist()
    },
    watch: {
        "infoid"(val) {
            val && this.getlist();
        }
    },
    methods: {
        //获取依赖信息
        async getdependlist() {
            const { data: res } = await this.$http.get(config.httpPrefix + "/alarm/record/depend/info");
            console.log(res.data);
            this.module_info = res.data.module_info
            this.level_info = res.data.level_info
            this.type_info = res.data.type_info
        },
        async getlist() {
            // console.log(this.infoid);
            const { data: res } = await this.$http.get(config.httpPrefix + "/alarm/record/info?id=" + this.infoid);

            this.form = res.data
            console.log(res);
            this.gradelist = res.data.grade;
            this.moduleslist = res.data.modules;
            this.operatelist = res.data.operate;
            this.tagslist = res.data.tags;
        },
        cancelForm() {
            // this.$refs["formName"].resetFields();
            this.$emit("closedrawer", 'close');
        },
        async commitForm() {
            // console.log(this.form);
            let resonlist = []
            if (this.radio === "数据值可信") {
                resonlist.push(this.radio);
            } else if (this.radio === "数据值不可信") {
                resonlist.push(...this.causeList);
            } else if (this.radio === "其他原因" && this.resontextarea) {
                resonlist.push(this.resontextarea);
            }
            // if (this.hardwareradio.length > 0) {
            //     this.hardwareradio.map(x => {
            //         resonlist.push(x)
            //     })
            // }
            // if (this.resontextarea) {
            //     resonlist.push(this.resontextarea)
            // }
            if (resonlist.length < 1) {
                return this.$message.error("必须填写原因");

            } else {
                // console.log(resonlist);
                const { data: res } = await this.$http.put(
                    config.httpPrefix + "/alarm/record/deal?id=" + this.infoid,
                    {
                        status: this.status,
                        handle_reason: resonlist,
                        handle_action: this.actiontextarea
                    }
                );
                if (res.code == 200) {
                    this.$emit('closedrawer', 'handled')
                    return this.$message.success("处理告警规则成功");

                }
            }
        },
        onCauseChange(value) {
            this.radio = value;
        }
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
    border-radius: 20px !important;
}

.authority {
    height: 100%;
    border-radius: 20px;
    margin-right: 15px;
    margin-left: 15px;

    .content {
        height: 900px !important;
        padding: 25px;
        border-radius: 20px;
        border: 0;
    }

    .info {
        height: 100%;
        width: 100%;
        .user {
            .message {
                color: rgba(95, 95, 95, 0.664);
            }

            .demo-drawer__footer {
                text-align: center;
            }

            .change-label-calss {
                .el-form-item__label {
                    width: 0 !important;
                }
            }
        }
    }

    .basic_box {
        margin-bottom: 30px;
        border-bottom: 1px solid rgba(219, 219, 219, 1);

        .basic_title {
            display: flex;
            align-items: center;
            height: 21px;
            opacity: 1;
            font-size: 16px;
            font-weight: 500;
            letter-spacing: 0px;
            line-height: 20.27px;
            color: rgba(36, 102, 168, 1);
            margin-bottom: 20px;

            img {
                height: 16px;
                margin-left: 6px;
            }
        }
    }

    .basic_text {
        font-size: 20px;
        margin-bottom: 20px;
        padding-bottom: 20px;
        color: rgba(184, 75, 75, 1);
        border-bottom: 1px solid rgba(219, 219, 219, 1);
    }

    .hardware_reason {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        .reason_name {
            margin-right: 20px;
        }
        .wrap-btn {
            margin-right: 26px;
            background: none;
            border: none;
        }
    }

    .reason_box {
        padding-left: 30px;
        padding-bottom: 30px;
        margin-bottom: 30px;
        border-bottom: 1px solid rgba(219, 219, 219, 1);
    }

    .action_box {
        margin-left: 30px;
        margin-bottom: 30px;
    }

    .another_reason {
        .reason_name {
            margin-bottom: 20px;
        }
    }
}

.add_title {
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 18.75px;
    color: rgba(36, 102, 168, 1);
    font-weight: 900;
    height: 40px;
    line-height: 40px;
    // margin-bottom: 20px;
    text-align: center;
}

::v-deep.el-collapse {
    border-top: 0px;
}

::v-deep.el-collapse-item__arrow {
    margin: 0 8px 0 10px;
}

::v-deep.el-textarea {
    width: 90%;
}
</style>
